<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbUniteMobile } from '@/models/alodb/AloDbUniteMobile'

@Component({
  name: 'AdminUniteMobileList'
})

export default class AdminUniteMobileList extends AdminList<AloDbUniteMobile> {  
 
  get itemTypeName() {
    return "UniteMobile"
  }

}
</script>